export default __webpack_public_path__ + "static/media/search-icon.fe5a600c.svg";